/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import {
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';
import { toggleButtonGroupClasses } from '@mui/material/ToggleButtonGroup';
import { styled } from '@mui/material/styles';
import StyledSelect from '../../common/StyledSelect';

const DocumentTypeToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  display: 'grid',
  gridAutoRows: '1fr',
  rowGap: 6,
  borderRadius: 8,
  backgroundColor: theme.palette.lighterPurple.main,
  padding: '25px 15px',
  marginBottom: 0,
  [`& .${toggleButtonGroupClasses.grouped}:not(:first-of-type)`]: {
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  },
  [`& .${toggleButtonGroupClasses.grouped}:not(:last-of-type)`]: {
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
}));

const DocumentTypeToggleButton = styled(ToggleButton)(({ theme }) => ({
  '&&&': {
    borderWidth: 2,
    color: 'white',
    borderColor: theme.palette.border.main,
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    marginLeft: 0,
    width: 224,
    paddingLeft: 17,
    paddingRight: 17,
    paddingTop: 10,
    paddingBottom: 10,
    textAlign: 'center',
    textTransform: 'none',
    lineHeight: 'normal',
    height: '100%',
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.darkGreen.dark,
    },
  },
}));

const DocumentTypeFilter = ({ options, value, onChange }) => (
  <>
    {/* Mobile Select */}
    <StyledSelect
      options={options}
      label="Document Type"
      value={value}
      onChange={onChange}
      sx={{ display: { xs: 'block', sm: 'none' } }}
    />
    {/* Desktop Toggle Buttons */}
    <DocumentTypeToggleButtonGroup
      orientation="vertical"
      value={value}
      exclusive
      onChange={(evt, val) => {
        if (val) {
          onChange(val);
        }
      }}
      sx={{ display: { xs: 'none', sm: 'grid' } }}
    >
      {options.map((option) => (
        <DocumentTypeToggleButton color="secondary" value={option.value} key={option.value}>
          {option.label}
        </DocumentTypeToggleButton>
      ))}
    </DocumentTypeToggleButtonGroup>
  </>
);

DocumentTypeFilter.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DocumentTypeFilter;
